import { render, staticRenderFns } from "./ListaUsuario.vue?vue&type=template&id=48545332"
import script from "./ListaUsuario.vue?vue&type=script&lang=js"
export * from "./ListaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports